import { useEffect } from 'react';

const SUFFIX = 'ZNK';

/**
 * A single-page app serves one index.html, so without this every route reports the
 * same <title> to search engines, browser history and shared bookmarks.
 * Pass null to keep the document default.
 */
const useDocumentTitle = (title: string | null, description?: string): void => {
  useEffect(() => {
    if (title) {
      document.title = title.includes(SUFFIX) ? title : `${title} | ${SUFFIX}`;
    }
    if (description) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute('content', description);
    }
  }, [title, description]);
};

export default useDocumentTitle;
